import { createRootRoute, Outlet } from '@tanstack/react-router';
import { lazy } from 'react';
import { UpdateGate } from '@/components/update-gate';
import { AppProviders } from '@/providers';

const Devtools = import.meta.env.DEV
  ? lazy(async () => {
      const [{ TanStackRouterDevtools }, { ReactQueryDevtools }] = await Promise.all([
        import('@tanstack/react-router-devtools'),
        import('@tanstack/react-query-devtools'),
      ]);
      return {
        default: () => (
          <>
            <TanStackRouterDevtools position="bottom-right" />
            <ReactQueryDevtools buttonPosition="bottom-left" />
          </>
        ),
      };
    })
  : () => null;

export const Route = createRootRoute({
  component: () => (
    <AppProviders>
      <Outlet />
      <UpdateGate />
      <Devtools />
    </AppProviders>
  ),
});
